import { all, put, takeEvery } from "redux-saga/effects";
import signinService from "../../../src/services/signinService";
import { GET_LOGIN_API } from "./types";
import * as signinAction from "./action";

function* verifySigninSaga(req) {
  try {
    const data = { email: req.values.email, password: req.values.password };
    const res = yield signinService
      .verifySignin(data)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
      });
    const key = res;
    localStorage.setItem("key",key);

    yield put(signinAction.setLoginAPI(key));
    const key3 = yield put(signinAction.getLoginAPI());

    if (key.length) {
      yield put(signinAction.setLoginSuccess(true));
    } else {
      yield put(signinAction.setLoginSuccess(false));
    }
  } catch (error) {
    yield put(signinAction.setLoginSuccess(false));
  }
}

export default function* SET_LOGIN_API() {
  yield all([takeEvery(GET_LOGIN_API, verifySigninSaga)]);
}
